// @ts-nocheck

import React from 'react';


import { optionalEquipmentTypes } from '../../../lib/enum';
import { Select, Option } from '../../ant/Select';

export default (props) =>
<Select {...props}>
    {Object.keys(optionalEquipmentTypes).map((key) =>
  <Option value={key} key={key}>
        {optionalEquipmentTypes[key]}
      </Option>
  )}
  </Select>;
